import { generatedEffects } from '@_config/store/effects.generated';

export const effects = [...generatedEffects];
